import { TranslateFunc } from 'src/components/translate';
import { PropertyValue } from 'schema-dts';
import { Maybe, Product, ProductPageFragment } from 'src/types';

export function corePropertyValue(
  product: Product &
    Maybe<{ coreProperties: ProductPageFragment['coreProperties'] }>,
  t: TranslateFunc
): PropertyValue[] {
  const booleanStrings = {
    true: t('product', 'property.boolean-yes'),
    false: t('product', 'property.boolean-no'),
  };

  return product!
    .coreProperties!.nodes!.filter(item => item.name && item.prettyTable)
    .map(item => ({
      '@type': 'PropertyValue',
      name: item.name!,
      value:
        item.type === 'boolean'
          ? booleanStrings[item.prettyTable || 'true']
          : item.prettyTable,
    }));
}
